import React, {useState} from "react";
import Stack from "@mui/material/Stack";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./Home.css";
import "./GoogleCSE.css"
import { CountryBar } from "./countryBar";
import { Search } from "@mui/icons-material";
import { addKeyword } from "../../HTTP/keywords";

const user = JSON.parse(localStorage.getItem("user"))
if (sessionStorage.getItem('listmiddle') === null) {
	sessionStorage.setItem('listmiddle', "De quoi parle-t-on ?")
}

const StyledMenu = styled((props) => (
	<Menu
		elevation={0}
		anchorOrigin={{
			vertical: "bottom",
			horizontal: "right",
		}}
		transformOrigin={{
			vertical: "top",
			horizontal: "right",
		}}
		{...props}
	/>
	))(({ theme }) => ({
	"& .MuiPaper-root": {
		borderRadius: 8,
		marginTop: theme.spacing(1),
		minWidth: 210,
		color:
			theme.palette.mode === "light"
				? "rgb(55, 65, 81)"
				: theme.palette.grey[300],
		boxShadow:
			"rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
		"& .MuiMenu-list": {
			padding: "4px 0",
		},
		"& .MuiMenuItem-root": {
			"& .MuiSvgIcon-root": {
				fontSize: 25,
				color: theme.palette.text.secondary,
				// marginRight: theme.spacing(1.5),
			},
			"&:active": {
				backgroundColor: alpha(
					theme.palette.primary.main,
					theme.palette.action.selectedOpacity
				),
			},
		},
	},
}));


export const ProfileHeader = (props) => {

	const setSelectedCountry = props.setSelectedCountry
	const selectedCountry = props.selectedCountry
	const selectedTheme = props.selectedTheme
	const funChangeDisplayMap = props.displayMap;
	const igo = props.igo;
    const igoReady = props.igoReady;
	const selectedIgo2 = props.selectedIgo;
    const funChangeIgo2 = props.setSelectedIgo;
	const links = props.links;
	const selectedSite = props.selectedSite;
	const searchInCse = props.searchInCse;
	const showSiteDropdown = props.showSiteDropdown;
	const setShowSiteDropdown = props.setShowSiteDropdown;
	const searchQuery = props.searchQuery;
	const setSearchQuery = props.setSearchQuery;
	const handleSearch = props.handleSearch;
	const handleSiteSelect = props.handleSiteSelect;

	const [anchorCountries, setAnchorCountries] = useState()

	const openCountries = (event) => setAnchorCountries(event.currentTarget)
	
	const closeCountries = () => setAnchorCountries(null)

	const profileHeaderDisplayMap = () => {
		funChangeDisplayMap()
		closeCountries()
	}

	const handleAddKeyword = async () => {
		const url = new URL(window.location.href)
		const thematic = url.searchParams.get('thematic') || sessionStorage.getItem("thematic")
		const thematic_link = url.searchParams.get('link-id') !== null ? url.searchParams.get('link-id') : null
		const keyword = {
			user_id: user.id,
			keyword: sessionStorage.getItem("search_query"),
			country_code: selectedCountry.code,
			thematic: thematic === "" || thematic === null ? "" : thematic,
			thematic_link
		}
		try {
			await addKeyword(keyword)
			alert("Keyword saved")
		} catch (error) {
			alert("Problem saving keyword")
		}
	}

	const isUserSubscribed = JSON.parse(localStorage.getItem("subscriptions")) !== null

	return (
		<div style={{display: "flex", flexDirection: "column", flexWrap: 'wrap'}} className="mt-10 mb-6">
			<div className="profile">
				<div className="icon">
					<Stack direction="row" spacing={2} id="stack_thing_in_header">
						<img 
							className="iconProfile" 
							src={user.profile_picture || process.env.PUBLIC_URL+"/profile_default.png" }
							alt="profile"
						 />
						
						<div className="profilename">
							<h2 className="notranslate">
								{ `${user?.firstname} ${user?.lastname}`} 
							</h2>
							{
								!isUserSubscribed && (
									<>
									<button
										className="btnpreprofile"
										onClick={() => window.location.href = "/Subscription"}
									>
										Passer a la version Premium
									</button>
									</>
								)
							}
						</div>
					</Stack>
				</div>
				<div className="name"></div>

				<div className="search">
					<div className="text-left mb-1">
						{selectedTheme}
					</div>
					<div className="custom-search-container">
						{/* Dropdown de sélection de site si des liens sont disponibles */}
						{links.length > 0 && !searchInCse && (
						<div className="site-selector">
							<div 
							className="selected-site" 
							onClick={() => setShowSiteDropdown(!showSiteDropdown)}
							>
							{selectedSite ? (
								<span className="site-name">{selectedSite.label}</span>
							) : (
								<span className="site-prompt">Tous les sites</span>
							)}
							<span className="dropdown-arrow">▼</span>
							</div>
							
							{showSiteDropdown && (
							<div className="site-dropdown">
								<div 
								className="site-option all-sites" 
								onClick={() => handleSiteSelect(null)}
								>
								Tous les sites
								</div>
								{links.map((site) => (
								<div 
									key={site.id} 
									className="site-option" 
									onClick={() => handleSiteSelect(site)}
								>
									{site.label}
								</div>
								))}
							</div>
							)}
						</div>
						)}
						
						{/* Votre barre de recherche personnalisée visible */}
						<div className="custom-search-wrapper">
						<input
							type="text"
							id="custom-search-input"
							className="custom-search-field"
							placeholder="Recherche..."
							value={searchQuery}
							onChange={(e) => setSearchQuery(e.target.value)}
							onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
						/>
						<button className="custom-search-button" onClick={handleSearch}>
							<span className="search-icon">
								<Search />
							</span>
						</button>
						</div>
						
						{/* La barre de recherche Google cachée mais fonctionnelle */}
						<div className="gcse-searchbox-hidden">
						<div className="gcse-searchbox" />
						</div>
					</div>

					<div className="translate-and-save flex flex-row justify-between space-x-10 lg:space-x-20 xl:space-x-40 mt-2">

						<div className={`flex items-center space-x-2`}>
							<input type="checkbox" id="translate_query" />
							<label htmlFor="translate_query">Traduction automatique</label>
							
						</div>
						{
							isUserSubscribed && (
								<button
									type="button"
									className="p-2 bg-savesearch hover:bg-savesearch text-black rounded-lg shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
									onClick={() => handleAddKeyword()}
									>
										Sauvegarder la recherche
									
								</button>
							)
						}
					</div>
				</div>

			</div>

			{ window.location.href[3] !== "friends-msg" && 
			<div className="droplist">

				<div className="list3 ">
					<Button
						style={{ backgroundColor: "#009AAD", paddingHorizontal: 120}}
						className="search_menu_selection_country"
						id="demo-customized-button"
						aria-controls={ Boolean(anchorCountries) ? "demo-customized-menu" : undefined}
						aria-haspopup="true"
						aria-expanded={ Boolean(anchorCountries) ? "true" : undefined}
						variant="contained"
						disableElevation
						onClick={ openCountries }
						endIcon={<KeyboardArrowDownIcon />}
					>

						{ selectedCountry.name }

					</Button>
					<StyledMenu
						id="demo-customized-menu"
						className="h-96"
						MenuListProps={{
							"aria-labelledby": "demo-customized-button",
						}}
						anchorEl={ anchorCountries }
						open={ Boolean(anchorCountries) }
						onClose={ closeCountries }
					>
						<CountryBar
							selectedCountry = {selectedCountry}
							setSelectedCountry = {setSelectedCountry}
							displayMap = {profileHeaderDisplayMap}
							isMobile = {true}
							igo = {igo}
							igoReady = {igoReady}
							selectedIgo = {selectedIgo2}
							setSelectedIgo = {funChangeIgo2}
							/>

					{/* <Divider sx={{ my: 0.5 }} /> */}
					</StyledMenu>
				</div>
			</div>
			

		} 
	</div>

	)
}
